import { render, staticRenderFns } from "./PolizasFinanzasListView.vue?vue&type=template&id=058cdbe9&"
import script from "./PolizasFinanzasListView.vue?vue&type=script&lang=js&"
export * from "./PolizasFinanzasListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports